// Generated on 2025-11-07T20:51:49.473Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "95769"
  },
  {
    "marca": "HONDA",
    "busquedas": "91176"
  },
  {
    "marca": "FORD",
    "busquedas": "76310"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "47276"
  },
  {
    "marca": "NISSAN",
    "busquedas": "42156"
  },
  {
    "marca": "KIA",
    "busquedas": "24486"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "22075"
  },
  {
    "marca": "MAZDA",
    "busquedas": "13984"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "13007"
  },
  {
    "marca": "JEEP",
    "busquedas": "12223"
  },
  {
    "marca": "ISUZU",
    "busquedas": "6947"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "4298"
  },
  {
    "marca": "BMW",
    "busquedas": "3014"
  },
  {
    "marca": "DODGE",
    "busquedas": "2718"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "2035"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "1916"
  },
  {
    "marca": "ACURA",
    "busquedas": "788"
  },
  {
    "marca": "SCION",
    "busquedas": "664"
  },
  {
    "marca": "GMC",
    "busquedas": "650"
  },
  {
    "marca": "RAM",
    "busquedas": "626"
  },
  {
    "marca": "MINI",
    "busquedas": "601"
  },
  {
    "marca": "SUBARU",
    "busquedas": "565"
  },
  {
    "marca": "MERCURY",
    "busquedas": "380"
  },
  {
    "marca": "LEXUS",
    "busquedas": "312"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "252"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "220"
  },
  {
    "marca": "VOLVO",
    "busquedas": "213"
  },
  {
    "marca": "INFINITI",
    "busquedas": "183"
  },
  {
    "marca": "HUMMER",
    "busquedas": "176"
  },
  {
    "marca": "SATURN",
    "busquedas": "164"
  },
  {
    "marca": "AUDI",
    "busquedas": "150"
  },
  {
    "marca": "GEO",
    "busquedas": "116"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "109"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "103"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "100"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "84"
  },
  {
    "marca": "FIAT",
    "busquedas": "34"
  },
  {
    "marca": "RENAULT",
    "busquedas": "31"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "28"
  },
  {
    "marca": "BUICK",
    "busquedas": "27"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "27"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "18"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "14"
  },
  {
    "marca": "JMC",
    "busquedas": "12"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "JAC",
    "busquedas": "6"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "3"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "JIM",
    "busquedas": "2"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "CHERY",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
